<template>
  <v-app id="sandbox">
    <core-toolbar v-bind="$attrs.toolbarAttrs">
     <template v-for="(_, name) in toolbarSlots" v-slot:[name]>
      <slot :name="name" />
    </template>
    </core-toolbar>

    <core-menu v-if="showMenu">
     <template v-for="(_, name) in menuSlots" v-slot:[name]>
      <slot :name="name" />
    </template>
    </core-menu>

    <v-main>
      <v-container fluid>
        <v-breadcrumbs v-if="showBreadcrumbs" :items="breadcrumbs" class="ml-1 pl-2 pb-0 pt-4 pl-0">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
              <v-icon v-if="item.icon" :color="breadcrumbColor(item)" small :x-small="$vuetify.breakpoint[$theme.options.compact.breadcrumbs]" left>{{item.icon}}</v-icon>&nbsp;
              <div :class="breadcrumbColorText(item)" class=" font-weight-bold">{{ item.text }}</div>
            </v-breadcrumbs-item>
          </template>
          <template v-slot:divider>
            <v-icon small>mdi mdi-chevron-double-right</v-icon>
          </template>
        </v-breadcrumbs>

        <v-row>
          <v-col cols="12">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <slot name="footer">
      <v-footer inset app>
        <span class="px-4">&copy; {{ new Date().getFullYear() }}</span>
      </v-footer>
    </slot>
  </v-app>
</template>

<script>
export default {
  props: {
    showMenu: { type: Boolean, default: true },
    showBreadcrumbs: { type: Boolean, default: true }
  },
  data () {
    return {

    }
  },
  computed: {
    toolbarSlots: function () {
      const slots = {}
      Object.keys(this.$slots).forEach(p => {
        if (p.startsWith('toolbar-')) { slots[p] = this.$slots[p] }
      })
      return slots
    },
    menuSlots: function () {
      const slots = {}
      Object.keys(this.$slots).forEach(p => {
        if (p.startsWith('menu-')) { slots[p] = this.$slots[p] }
      })
      return slots
    },
    breadcrumbs: function () {
      var route = this.$route
      if (route.meta.breadcrumbs) {
        return route.meta.breadcrumbs.map(function (p, i) {
          if (i === route.meta.breadcrumbs.length - 1) { p.disabled = true }

          return p
        })
      } else return []
    }
  },
  methods: {
    breadcrumbColor (item) {
      return (this.$theme.options.breadcrumbs.color || 'secondary') +
     (item.disabled ? ' lighten-2' : '')
    },
    breadcrumbColorText (item) {
      return (this.$theme.options.breadcrumbs.color || 'secondary') + '--text' +
     (item.disabled ? 'text--lighten-2' : '') + ' ' +
     (this.$vuetify.breakpoint[this.$theme.options.compact.breadcrumbs] ? 'text-body-2' : 'text-h6')
    },
  }
}
</script>
